export default "__VITE_ASSET__009d3bf2__"